<template>
    <div class='container'>

        <div class="about">
            <div class="header">
                <div class="title">關於</div>
                <div class="line"></div>
                <div class="row">
                    <div class="col-md-8">
                        <div class="left">
                            <div class="icon">
                                <h3 class="mb-0 text">{{ seo.og_title }}</h3>
                                <ul class="social_list d-flex list-unstyled mb-0" v-if="website.company_info">
                                    <li><span v-for="item in website.company_info">
                                            <a class="d-block" v-if="item.key == 'FB_Link'" :href="item.value"
                                                target="_blank"><img class="mw-100" src="@/assets/svg/img_facebook.svg"
                                                    width="30" height="30" alt="facebook"></a>
                                        </span></li>
                                    <li><span v-for="item in website.company_info">
                                            <a class="d-block" v-if="item.key == 'Line_Link'" :href="item.value"
                                                target="_blank"><img class="mw-100" src="@/assets/svg/img_line.svg"
                                                    width="30" height="30" alt="line"></a>
                                        </span></li>
                                    <li>
                                        <a class="d-block" href="/" alt="商城首頁">
                                            <svg data-name=" 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72"
                                                style="width: 30px;">

                                                <circle class="cls-1" cx="36" cy="36" r="36"></circle>
                                                <path class="cls-2"
                                                    d="M41.62,33.6a3.3,3.3,0,0,1-3.25-2.36V18h4.45l2.06,6.44v5.9a3.27,3.27,0,0,1-3.26,3.26Z">
                                                </path>
                                                <path class="cls-2"
                                                    d="M30.38,33.6a3.27,3.27,0,0,1-3.26-3.26v-5.9L29.18,18h4.45V30.34a3.26,3.26,0,0,1-3.25,3.26Z">
                                                </path>
                                                <path class="cls-2"
                                                    d="M19.14,33.6a3.27,3.27,0,0,1-3.26-3.26V24.66L19.43,18h4.78l-1.82,5.7v6.64a3.26,3.26,0,0,1-3.25,3.26Z">
                                                </path>
                                                <path class="cls-2" d="M32.41,45.91h7.31V54H32.41Z"></path>
                                                <path class="cls-2"
                                                    d="M44.45,54V43.54a2.37,2.37,0,0,0-2.36-2.37H30a2.37,2.37,0,0,0-2.37,2.37V54H21.94a1.64,1.64,0,0,1-1.64-1.65V38.24A8,8,0,0,0,24.76,36h0a8,8,0,0,0,11.18.06h0s.09.08.13.13a8.27,8.27,0,0,0,5.55,2.13h0A7.86,7.86,0,0,0,47.24,36h0a8,8,0,0,0,4.42,2.23h0v14.1A1.65,1.65,0,0,1,50.06,54H44.45Z">
                                                </path>
                                                <path class="cls-2"
                                                    d="M52.86,33.6a3.26,3.26,0,0,1-3.25-3.26V23.7L47.79,18H52.6c1.68,3,3.07,5.61,3.52,6.53v5.81a3.27,3.27,0,0,1-3.26,3.26Z">
                                                </path>
                                            </svg>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="about_icon d-flex">

                        </div>
                    </div>
                </div>
            </div>
            <div v-for="item in getfooter" v-if="item.name == '關於'">
                <div v-html="item.content"></div>
            </div>
        </div>
    </div>
</template>
<script>
// import $ from 'jquery'
import { mapState } from 'vuex';
export default {
    components: {},
    data() {
        return {
            data: [],
            webmeta: {
                og_title: '',
                about_title: '',
                about_description:''
            }
        };
    },
    computed: {
        ...mapState('header', ['getfooter', 'cate', 'website', 'getnav', 'seo']),
        computedOgTitle() {
            return this.seo.og_title || '';
        },
        computedTitle() {
            return this.seo.about_title || '';
        },
        computedDescription(){
            return this.seo.about_description || '';
        }
    },
    metaInfo() {
        return {
            title: this.webmeta.about_title || this.webmeta.og_title,
            meta: [
                { vmid: 'description', name: 'description', content: this.webmeta.about_description },
            ]
        }
    },
    watch: {},
    methods: {
    },
    created() {
        this.webmeta.og_title = this.computedOgTitle;
        this.webmeta.about_title = this.computedTitle;
        this.webmeta.about_description = this.computedDescription;
    },
    mounted() {
        for (const key in this.getfooter) {
            if (this.getfooter[key].name == "關於") {
                this.data.push(this.getfooter[key])
            }
            // console.log(this.getfooter[key]);
        }
        // console.log( $('#navbar-nav')[0].childNodes);
        // $('#navbar-nav')[0].childNodes.forEach(element => {
        //     $(element).removeClass('active')
        //     if(element.childNodes[0].childNodes[0].innerText=='關於'){
        //         $(element).addClass('active')
        //     }

        //     });
        // this.$store.dispatch('header/getnav').then(e => {
        //     if (e.about_title !== '' && e.about_title !== null && e.about_title !== undefined ) {
        //         this.webmeta = e;
        //     }
        // }).catch(e => {})


    },
}
</script>
<style lang='scss' scoped src="./index.scss"></style>
<style lang='scss' scoped >
::v-deep img {
    width: 100% !important;
}
</style>